(function () {
    'use strict';
    document.querySelectorAll('[data-video-id]').forEach(function (media) {
        var button = media.querySelector('.bh-video-load');
        var id = media.getAttribute('data-video-id');
        if (!button || !/^[A-Za-z0-9_-]{11}$/.test(id)) return;
        button.hidden = false;
        button.addEventListener('click', function () {
            var frame = document.createElement('iframe');
            frame.src = 'https://www.youtube.com/embed/' + id;
            frame.title = media.closest('article').querySelector('h2').textContent;
            frame.width = '560';
            frame.height = '315';
            frame.loading = 'lazy';
            frame.referrerPolicy = 'strict-origin-when-cross-origin';
            frame.allow = 'accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
            frame.allowFullscreen = true;
            media.replaceChildren(frame);
            frame.focus();
        }, {once: true});
    });
}());
